/**
 * 10.9FC — GRIMORIO. Cada classe tem 6 magias (3 de base + 3 novas liberadas nos Nv 10/25/40).
 * O jogador escolhe quais 3 ficam nos botoes de magia. Escolha livre (inclusive 2 buffs).
 */
import { i18n } from "../i18n/i18n";

export interface GrimoireSpell { id?: string; kind: string; nameKey: string; descKey?: string; cooldown: number; color: number; unlockLevel?: number }

export class GrimoireScreen {
  private readonly root: HTMLDivElement;
  private slot = 0;

  constructor(uiRoot: HTMLElement, private readonly h: { onEquip: (slot: number, id: string) => void; onClose: () => void }) {
    this.root = document.createElement("div");
    this.root.className = "overlay grim-overlay";
    this.root.hidden = true;
    uiRoot.appendChild(this.root);
  }

  hide(): void { this.root.hidden = true; }

  open(book: GrimoireSpell[], equipped: string[], level: number, emoji: Record<string, string>): void {
    const esc = (t: string): string => t.replace(/[&<>"]/g, (c) => ({ "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;" }[c]!));
    const hex = (c: number): string => "#" + c.toString(16).padStart(6, "0");
    const byId = (id: string): GrimoireSpell | undefined => book.find((b) => b.id === id);
    let html = `<div class="panel grim-panel"><button class="close-x" data-a="close">✕</button><h2>📖 ${esc(i18n.t("grim.title"))}</h2>
      <div class="grim-hint">${esc(i18n.t("grim.hint"))}</div><div class="grim-slots">`;
    for (let i = 0; i < 3; i++) {
      const s = byId(equipped[i]);
      html += `<button class="grim-slot${i === this.slot ? " sel" : ""}" data-slot="${i}" style="--c:${s ? hex(s.color) : "#666"}">
        <span class="grim-n">${i + 1}</span><span class="grim-ic">${s ? emoji[s.kind] ?? "✨" : "—"}</span>
        <span class="grim-nm">${s ? esc(i18n.t(s.nameKey)) : ""}</span></button>`;
    }
    html += `</div><div class="grim-list">`;
    for (const s of book) {
      const locked = level < (s.unlockLevel ?? 0);
      const inSlot = equipped.indexOf(s.id ?? "");
      html += `<button class="grim-spell${locked ? " locked" : ""}${inSlot >= 0 ? " on" : ""}" data-id="${s.id}" style="--c:${hex(s.color)}"${locked ? " disabled" : ""}>
        <span class="grim-ic">${emoji[s.kind] ?? "✨"}</span>
        <span class="grim-body"><b>${esc(i18n.t(s.nameKey))}</b>${s.kind === "buff" ? ` <em class="grim-tag">${esc(i18n.t("grim.buff"))}</em>` : ""}
        <small>${s.descKey ? esc(i18n.t(s.descKey)) : ""}</small>
        <small class="grim-cd">⏱ ${s.cooldown}s</small></span>
        <span class="grim-state">${locked ? `🔒 ${esc(i18n.t("grim.lvl", { n: String(s.unlockLevel) }))}` : inSlot >= 0 ? `✔ ${inSlot + 1}` : ""}</span>
      </button>`;
    }
    html += `</div></div>`;
    this.root.innerHTML = html;
    this.root.querySelector<HTMLButtonElement>('[data-a="close"]')!.onclick = () => this.h.onClose();
    this.root.querySelectorAll<HTMLButtonElement>(".grim-slot").forEach((b) => { b.onclick = () => { this.slot = Number(b.dataset.slot); this.open(book, equipped, level, emoji); }; });
    this.root.querySelectorAll<HTMLButtonElement>(".grim-spell:not(.locked)").forEach((b) => { b.onclick = () => this.h.onEquip(this.slot, b.dataset.id!); });
    this.root.hidden = false;
  }
}
